/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Context } from '@nuxt/types';
import createAuth0Client from '@auth0/auth0-spa-js';
import { Authentication } from 'auth0-js';
import { Auth0Client } from '~/services/authentication';
import { Settings } from '~/services/settings';
export default async (context: Context, inject: (name: string, value: any) => void) => {
    const container = context.container;
    const settings = context.container.get(Settings);
    const spaClient = await createClient({
        audience: context.env.authAudience,
        domain: context.env.authDomain,
        clientId: context.env.authClientId,
        redirectUri: settings.absoluteUrl('')
    });
    const auth0 = new Authentication({
        audience: context.env.authAudience,
        domain: context.env.authDomain,
        clientID: context.env.authClientId,
        redirectUri: settings.absoluteUrl(''),
    });
    container.registerInstance(Auth0Client, spaClient);
    container.registerInstance(Authentication, auth0);
};
function createClient({
    redirectUri = window.location.origin,
    ...options
}: {
    redirectUri?: string;
    domain: string;
    clientId: string;
    audience: string;
}) {
    // Create a new instance of the SDK client using members of the given options object
    return createAuth0Client({
        domain: options.domain,
        client_id: options.clientId,
        audience: options.audience,
        redirect_uri: redirectUri,
        prompt: 'login',
        useRefreshTokens: true
    });
}
